import {Button, Stack, TextField} from '@mui/material';
import {usePDF} from '@react-pdf/renderer';
import {useEffect, useState} from 'react';
import {etsySettings} from '@coolcolduk/etsy';
import {HookAccountToken} from '../../../hook/useGetAllAccountToken';
import {useGetShopByOwnerUserId} from '../../../hook/useGetShopByOwnerUserId';
import EtsyDigitalDraftPdf from './EtsyNewSingleListingPdf';

export interface EtsyNewSingleListingGeneratorProps {
  selectedAccount: HookAccountToken;
  setFile: (pdfFile: File | null) => void;
}

/**
 * Section for generating pdf
 * @param param0
 * @returns
 */
export default function EtsyNewSingleListingGenerator({selectedAccount, setFile}: EtsyNewSingleListingGeneratorProps) {
  const [link, setLink] = useState('');
  const [instruction, setInstruction] = useState('');
  const [title, setTitle] = useState('');
  const shop = useGetShopByOwnerUserId(selectedAccount.id);

  const [pdf, updatePdf] = usePDF({
    document: <EtsyDigitalDraftPdf title={title} link={link} instruction={instruction} shop={shop} />,
  });
  useEffect(() => {
    updatePdf(<EtsyDigitalDraftPdf title={title} link={link} instruction={instruction} shop={shop} />);
  }, [title, link, instruction, shop, updatePdf]);

  const handleDownload = () => {
    if (pdf.url) {
      const l = document.createElement('a');
      l.href = pdf.url;
      l.download = 'digital_download.pdf';
      l.click();
    }
  };

  useEffect(
    () => setFile(pdf.blob ? new File([pdf.blob], 'digital_product.pdf', {type: 'application/pdf'}) : null),
    [pdf, setFile],
  );
  return (
    <Stack spacing={2}>
      <TextField
        fullWidth
        label="Link"
        value={link}
        onChange={(e) => setLink(e.target.value)}
        helperText="Link to add to pdf file"
      />
      <TextField
        fullWidth
        label="Instruction"
        value={instruction}
        onChange={(e) => setInstruction(e.target.value)}
        helperText="Instruction link to add to pdf file"
      />

      <TextField
        fullWidth
        label="Pdf title"
        value={title}
        onChange={(e) => setTitle(e.target.value.slice(0, etsySettings.listing.title.maxLength))}
        slotProps={{htmlInput: {maxLength: etsySettings.listing.title.maxLength}}}
        helperText="Title to be used in pdf file"
      />

      <Button variant="contained" color="primary" onClick={handleDownload} disabled={pdf.loading}>
        {pdf.loading ? 'Generating PDF...' : 'Download PDF for preview'}
      </Button>
    </Stack>
  );
}
